// This file is auto-generated by @hey-api/openapi-ts

import { client } from './Client.gen';
import type { EshopPortableCardControllerAttachData } from './EshopPortableCardControllerAttachData.gen';
import type { EshopPortableCardControllerAttachErrors } from './EshopPortableCardControllerAttachErrors.gen';
import type { EshopPortableCardControllerAttachResponses } from './EshopPortableCardControllerAttachResponses.gen';
import type { EshopPortableCardControllerRegistrationAllowedCheckData } from './EshopPortableCardControllerRegistrationAllowedCheckData.gen';
import type { EshopPortableCardControllerRegistrationAllowedCheckErrors } from './EshopPortableCardControllerRegistrationAllowedCheckErrors.gen';
import type { EshopPortableCardControllerRegistrationAllowedCheckResponses } from './EshopPortableCardControllerRegistrationAllowedCheckResponses.gen';
import type { Options } from './Options.gen';

export class EshopPortableCardController {
    /**
     * Check if user can register portable card.
     */
    public static registrationAllowedCheck<ThrowOnError extends boolean = false>(options?: Options<EshopPortableCardControllerRegistrationAllowedCheckData, ThrowOnError>) {
        return (options?.client ?? client).get<EshopPortableCardControllerRegistrationAllowedCheckResponses, EshopPortableCardControllerRegistrationAllowedCheckErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/portable-cards/registration-allowed-check',
            ...options
        });
    }
    
    /**
     * Attach portable card to customer account.
     *
     * Require: `PERMISSION_CUSTOMER-CARDS_EDIT`<br>
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **VALIDATION_ERROR** - Invalid body, check 'errors' property for more info.<br>
     * + **CARD_NUMBER_NOT_UNIQUE** - Card number already exists.
     */
    public static attach<ThrowOnError extends boolean = false>(options: Options<EshopPortableCardControllerAttachData, ThrowOnError>) {
        return (options.client ?? client).post<EshopPortableCardControllerAttachResponses, EshopPortableCardControllerAttachErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/portable-cards/attach-to-account',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
